const VALID_NAME_PATTERN = /^[-a-zA-ZÀ-ÖØ-öø-ÿ. ]+$/

const isPersonName = maybeValidName =>
  typeof maybeValidName === 'string' && VALID_NAME_PATTERN.test(maybeValidName)

export default isPersonName
